import { Route, Routes } from "react-router-dom";
import CustomerListPage from "./CustomerListPage";
import CustomerPage from "./CustomerPage";

const CustomerPages = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<CustomerListPage />} />
        <Route path=":id" element={<CustomerPage />} />
      </Route>
    </Routes>
  );
};

export default CustomerPages;
